import React, { Component } from "react";
import { Link } from "react-router-dom";
import DashboardHeader from "../../Header/DashboardHeader";
import DashboardFooter from "../../Footer/DashboardFooter";
import DashboardLeftMenu from "../../Dashboard/DashboardLeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faEye,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { HOST_URL } from "../api/Api";
import Axios from "../../../axios/Axios";
import { handleUserLog } from "../../Utils/Utils";

class SmsReports extends Component {
  constructor() {
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;

    var today = new Date(),
      date =
        today.getFullYear() +
        "-" +
        ("0" + (today.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + today.getDate()).slice(-2);
    super();
    this.state = {
      user_id: userId,
      token: userToken,
      TodayDate: date,
      channel: "sms",
      smsReports: "",
      smsReportsKeys: "",
      voiceReports: "",
      voiceReportsKeys: "",
      emailReports: "",
      emailReportsKeys: "",
      dateFrom: date,
      dateTo: date,
      SelecteddateFrom: "",
      SelecteddateTo: "",
      errorMessage: "",
      smsSuccessMessage: false,
      voicesuccessMessage: false,
      emailSuccessMessage: false,
      resultUpdate: false,
      bgColor: "",
      isLoading: false,
    };

    this.FilterDateWise = this.FilterDateWise.bind(this);
  }

  componentDidMount() {
    this.setState({ isLoading: true }, () => {
      this.smsReportSummery(this.state.TodayDate, this.state.TodayDate);
    });
  }

  smsReportSummery = async (dateFrom, dateTo) => {
    let paramData = {
      user_id: this.state.user_id,
      method: "summary",
      token: this.state.token,
      date_from: dateFrom,
      date_to: dateTo
    }
    let { data } = await Axios.post(`${HOST_URL}/sms_report.php`, paramData)
    if (data.success === true) {
      this.setState({
        smsReports: data.message,
        smsReportsKeys: Object.keys(data.message),
        isLoading: false,
      });
    } else {
      this.setState({
        smsSuccessMessage: true,
        errorMessage: data.message,
        bgColor: "alert alert-danger alert-dismissible",
        isLoading: false,
      });
    }
  }

  dataDownload() {
    const formData = new FormData();
    formData.append("user_id", this.state.user_id);
    formData.append("method", "download");
    formData.append("channel", this.state.channel);
    formData.append("token", this.state.token);
    formData.append("date_from", this.state.dateFrom);
    formData.append("date_to", this.state.dateTo);

    fetch(`${HOST_URL}/user_report.php`, {
      method: "POST",
      body: formData
    })
      .then(response => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "user_report.csv"; // Or detect from server headers
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error("Download failed:", error);
      });
  }



  FilterDateWise() {
    this.setState({
      resultUpdate: true,
      errorMessage: "Result Updated",
      bgColor: "alert alert-success alert-dismissible",
      isLoading: true,
    });

    this.smsReportSummery(this.state.dateFrom, this.state.dateTo);
  }


  dateFrom = (date) => {
    let dated =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    this.setState({
      dateFrom: dated,
      SelecteddateFrom: date,
    });
  };

  dateTo = (date) => {
    let dated =
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    this.setState({
      dateTo: dated,
      SelecteddateTo: date,
    });
  };

  render() {
    return (
      <div className="wrapper">
        <DashboardLeftMenu />
        <div className="main">
          <DashboardHeader />
          <main className="content">
            <div className="container-fluid p-0">
              <div className=" mb-2 mb-xl-3">
                <div className="col-auto d-none d-sm-block">
                  <h3>
                    <strong>SMS</strong> Reports{" "}
                  </h3>
                </div>
              </div>
              <div className="">
                <div className="card">
                  <div className="">
                    <h5 className="card-title mt-5">
                      <div className="col-auto ml-auto text-right mt-n1">
                        <nav className="text-center" aria-label="breadcrumb">
                          <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                            <Link to="/dashboard/sms-report">
                              <li onClick={() => handleUserLog("" , "clicked_today_summary_tab" , "sms" , "User Click on Today Summary tab in report" , "sms_report" , "" , "")} className="breadcrumb-item active">
                                {" "}
                                Today's Summary{" "}
                              </li>{" "}
                            </Link>
                            <Link
                              to={
                                "/dashboard/sms-detail-reports/" +
                                "sms/" +
                                this.state.dateFrom +
                                "/" +
                                this.state.dateTo
                              }
                            >
                              {" "}
                              <li onClick={() => handleUserLog("" , "clicked_detailed_reports_tab" , "sms" , "User Click on Detailed Reports tab in report" , "sms_report" , "" , "")} className="breadcrumb-item ">
                                {" "}
                                Detailed Reports{" "}
                              </li>{" "}
                            </Link>
                            <Link
                              to={
                                "/dashboard/sms-template-summary"
                              }
                            >
                              {" "}
                              <li onClick={() => handleUserLog("" , "clicked_template_summary_tab" , "sms" , "User Click on Template Summary tab in report" , "sms_report" , "" , "")} className="breadcrumb-item ">
                                {" "}
                                Template Summary{" "}
                              </li>{" "}
                            </Link>
                          </ol>
                        </nav>
                      </div>
                    </h5>
                  </div>

                  <div className="card-body">
                    <div className="filter-option">
                      <h6 className="card-subtitle text-muted">
                        Select Data Range{" "}
                      </h6>
                      <div className="row">
                        <div className="col-md-1">
                          <div className="btn-block mb-2 mr-sm-2">
                            <label
                              className="mt-2"
                              for="inlineFormCustomSelectPref"
                            >
                              From
                            </label>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4">
                          <div className="input-group mb-2 mr-sm-2">
                            <div className="input-group-text d-flex align-items-center justify-content-center" style={{ width: '40px' }}>
                              <FontAwesomeIcon icon={faCalendarAlt} />
                            </div>
                            <DatePicker
                              className="form-control react-datepicker-popper"
                              dateFormat="yyyy/MM/dd"
                              value={this.state.dateFrom}
                              onChange={this.dateFrom}
                              selected={this.state.SelecteddateFrom}
                              placeholderText="From Date"
                            />
                          </div>
                        </div>
                        <div className="col-md-1">
                          <div className="btn-block mb-2 mr-sm-2">
                            <label
                              className="mt-2"
                              for="inlineFormCustomSelectPref"
                            >
                              To
                            </label>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                          <div className="input-group mb-2 mr-sm-2 d-flex">
                            <div className="input-group-text d-flex align-items-center justify-content-center" style={{ width: '40px' }}>
                              <FontAwesomeIcon icon={faCalendarAlt} />
                            </div>
                            <DatePicker
                              className="form-control react-datepicker-popper"
                              dateFormat="yyyy/MM/dd"
                              value={this.state.dateTo}
                              onChange={this.dateTo}
                              selected={this.state.SelecteddateTo}
                              placeholderText="Date To"
                            />
                          </div>
                        </div>

                        <div className="col-md-2">
                          <div className="input-group btn-block mb-2 mr-sm-2">
                            <button
                              onClick={() => {
                                handleUserLog("" , "search_button" , "sms" , "User Click on Search Button in report" , "sms_report" , "" , { date_from: this.state.dateFrom, date_to: this.state.dateTo });
                                this.FilterDateWise();
                              }}
                              className="btn mt-1 btn-blue btn-sm  btn-block"
                            >
                              Search{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {this.state.resultUpdate ? (
                      <div className={this.state.bgColor} role="alert">
                        <button
                          type="button"
                          className="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                        <div className="">{this.state.errorMessage}</div>
                      </div>
                    ) : null}

                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">
                            <h4 className="summary-title">SMS</h4>

                            {this.state.smsSuccessMessage ? (
                              <div className={this.state.bgColor} role="alert">
                                <button
                                  type="button"
                                  className="close"
                                  data-dismiss="alert"
                                  aria-label="Close"
                                >
                                  <span aria-hidden="true">×</span>
                                </button>
                                <div className="">
                                  {this.state.errorMessage}
                                </div>
                              </div>
                            ) : null}

                            {this.state.isLoading && (
                              <div className="text-center my-4">
                                <div className="spinner-border " role="status">
                                </div>
                              </div>
                            )}

                            {!this.state.isLoading && this.state.smsReports ? (
                              <div className="d-flex flex-wrap  summary-data text-center">
                                {this.state.smsReportsKeys.map((item, i) => (
                                  <div className="mb-1">
                                    <span className="text-muted"> {item} </span>{" "}
                                    <br />{" "}
                                    <Link
                                      to={
                                        "/dashboard/sms-detail-reports/" +
                                        "sms/" +
                                        this.state.dateFrom +
                                        "/" +
                                        this.state.dateTo
                                      }
                                    >
                                      {" "}
                                      <span className="text-success">
                                        {" "}
                                        {this.state.smsReports[item]}{" "}
                                      </span>{" "}
                                    </Link>
                                  </div>
                                ))}

                                <div className="mb-1">
                                  <span className="text-muted"> View </span>{" "}
                                  <br />{" "}
                                  <Link
                                    to={
                                      "/dashboard/sms-detail-reports/" +
                                      "sms/" +
                                      this.state.dateFrom +
                                      "/" +
                                      this.state.dateTo
                                    }
                                  >
                                    {" "}
                                    <span onClick={() => handleUserLog("" , "view_button" , "sms" , "User Click on View Button in report" , "sms_report" , "" , { date_from: this.state.dateFrom, date_to: this.state.dateTo })} className="text-success">
                                      <FontAwesomeIcon icon={faEye} />
                                    </span>{" "}
                                  </Link>
                                </div>

                                <div className="mb-1">
                                  <span className="text-muted"> Download </span>{" "}
                                  <br />{" "}
                                  <Link>
                                    {" "}
                                    <span
                                      onClick={() => {
                                        handleUserLog("" , "sms_today_summary_downloaded" , "sms" , "User Click on Download Button in report" , "sms_report" , "" , { date_from: this.state.dateFrom, date_to: this.state.dateTo, channel: this.state.channel });
                                        this.dataDownload();
                                      }}
                                      className="text-success"
                                    >
                                      <FontAwesomeIcon icon={faDownload} />
                                    </span>{" "}
                                  </Link>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <DashboardFooter />
        </div>
      </div>
    );
  }
}
export default SmsReports;
